import { Injectable } from '@angular/core';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { Person } from '../interfaces/person.interface';

@Injectable({
  providedIn: 'root'
})
export class IndividualMarketPersonsService {
  constructor(private reducerUtilityService: ReducerUtilityService) {}

  _getFromDataFromState(connectPath: string, formControlName: string): Person[] {
    const payloadStates = this.reducerUtilityService.getPayloadStates();
    const splitPath = connectPath.split('.');

    /** Recursive grab data from nested state structure by leveraging the [connect] format of dot.notation.objects */
    const recursiveStateLookup = (path: string[], index: number, obj: any) => {
      if (obj[path[index]] && index !== path.length - 1) {
        return recursiveStateLookup(path, index + 1, obj[path[index]]);
      }

      if (index === path.length - 1) {
        return obj[path[index]];
      }

      return null;
    };

    const currentState: { [key: string]: Person[] } = recursiveStateLookup(splitPath, 0, payloadStates);

    if (currentState && currentState[formControlName]) {
      return currentState[formControlName];
    } else {
      return null;
    }
  }

  _parseDataFromState(dataAsObj: { [key: number]: Person }): Person[] {
    const persons: Person[] = [];
    Object.keys(dataAsObj).forEach(k => persons.push(dataAsObj[k]));
    return persons;
  }

  getPersonsData(connectPath: string, formControlName: string): Person[] {
    const formData = this._getFromDataFromState(connectPath, formControlName);
    if (formData) {
      const data = this._parseDataFromState(formData);
      return data;
    } else {
      return null;
    }
  }
}
